import { render, staticRenderFns } from "./IconCheckOn.vue?vue&type=template&id=965518f0&"
import script from "./IconCheckOn.vue?vue&type=script&lang=ts&"
export * from "./IconCheckOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports